import React from 'react';
import { Components, Utils } from 'versafleet-core';
import Logo from './logo';

const SsoError = () => (
  <div>
    <Logo className="vf-authentication__sso-login__error-logo" />
    <div className="vf-authentication__sso-login__error-form-container">
      <div className="vf-authentication__sso-login__text--bold">
        Login Unsuccessful
      </div>
      <br />
      <div>
        {window.atob(Utils.Router.getQuery().error)}
        <br />
        <br />
        Please contact your IT service desk if you need further assistance.
      </div>
      <br />
      <div>
        <Components.Button
          className="vf-authentication__sso-login__login-button"
          fillColor
          onClick={() => Utils.Router.transitionTo(`/auth/login/sso/${Utils.Router.getParams().domain}`)}
        >
          Try again
        </Components.Button>
      </div>
    </div>
  </div>
);

SsoError.displayName = 'Sso Error';

export default SsoError;
